@use "../../../src/styles/Colors.scss" as Colors;
@use "../../../src/styles/Constants.scss" as Constants;

$var-dropzone-height: 80px;

.dropzone-element {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	height: $var-dropzone-height;
	border: 2px dashed Colors.$col-greyConnection;
	color: Colors.$col-greyFontLight;
	
	&__select-files-button {
		cursor: pointer;
		margin-left: Constants.$val-spacing-m;
	}
}